import React, { Component } from "react";

// Components
import ApiList from "./ApiList";
import BundleList from "./BundleList";
import { ApiSearchGroup } from "./ApiSearchGroup";
import SearchResult from "./SearchResult";
import "../api-directory.css";
import {
  AMPLITUDE_EVENTS,
  AMPLITUDE_PROPERTIES,
} from "../../../../utils/AmplitudeConstants";

import {
  Loader,
  FlexFooterContainer,
  SecondaryButton,
  Toast,
  TOAST_VARIANTS,
} from "cdk-radial";

import {
  API_TYPES_DROPDOWN_OPTIONS,
  PAGINATION,
  PAGINATION_BUNDLE,
  FILTER_TYPES_DROPDOWN_OPTIONS,
  PAGINATION_CONTRACTED_APIS,
  SHOW_MORE_APIS,
} from "../../constants";

import Fuse from "fuse.js";
import { API_DIRECTORY_THEME } from "../../../../utils/constants";

class ApiSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: this.props.searchString || "",
      selectedAPIType: [],
      selectedDomainIds: [],
      chipDomainOptions: [],
      visible: PAGINATION.LIMIT,
      visibleBundle: PAGINATION_BUNDLE.LIMIT,
      visibleContractedApis: PAGINATION_CONTRACTED_APIS.LIMIT,
      isPaginationRequired: true,
      selectedOrgs: [],
      entity: {},
      apiBundles: [],
      advanceSearch: true,
      hasBundles: false,
      hasContractedApis: false,
      selectedFilterType: [],
    };
    this.loadMore = this.loadMore.bind(this);
    this.loadMoreBundle = this.loadMoreBundle.bind(this);
    this.loadMoreContractedApis = this.loadMoreContractedApis.bind(this);
  }

  loadMore() {
    this.setState((prev) => {
      return { visible: prev.visible + PAGINATION.LIMIT };
    });
    this.props.sendAmplitudeData(AMPLITUDE_EVENTS.SHOW_MORE_APIS);
  }

  loadMoreContractedApis() {
    this.setState((prev) => {
      return {
        visibleContractedApis:
          prev.visibleContractedApis + PAGINATION_CONTRACTED_APIS.LIMIT,
      };
    });
  }

  loadMoreBundle() {
    const paginationLimit =
      Array.isArray(this.state.selectedAPIType) &&
      this.state.selectedAPIType.indexOf(
        FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
      ) > -1 &&
      this.state.selectedAPIType.length === 1
        ? PAGINATION_BUNDLE.EXTENDED_LIMIT
        : PAGINATION_BUNDLE.LIMIT;

    this.setState((prev) => {
      return { visibleBundle: prev.visibleBundle + paginationLimit };
    });
  }

  onEnhancedChange = (event, domainId = "", orgs = [], filters) => {
    const paginationLimit =
      (Array.isArray(filters) &&
        filters.length === 1 &&
        filters.indexOf(FILTER_TYPES_DROPDOWN_OPTIONS[0].value) > -1) ||
      (Array.isArray(event) &&
        event.length === 1 &&
        event.indexOf(FILTER_TYPES_DROPDOWN_OPTIONS[0].value) > -1)
        ? PAGINATION_BUNDLE.EXTENDED_LIMIT
        : PAGINATION_BUNDLE.LIMIT;

    this.setState({
      selectedAPIType: event,
      selectedDomainIds: domainId,
      visible: PAGINATION.LIMIT,
      visibleBundle: paginationLimit,
      visibleContractedApis: PAGINATION_CONTRACTED_APIS.LIMIT,
      isPaginationRequired: true,
      selectedOrgs: orgs,
      selectedFilterType: filters,
    });
  };

  handleSetSearchFilters = (searchFilters, source = "") => {
    let selectedApiTypes = [];
    let locOrgs = [];
    let locCategories = [];
    let locFilters = [];

    if (source === "searchText") {
      selectedApiTypes = searchFilters["apiType"];
      locCategories = searchFilters["category"];
      locOrgs = searchFilters["org"];
      locFilters = searchFilters["filterType"];
    } else {
      if (!!searchFilters.category) {
        Object.keys(searchFilters.category).forEach((f) => {
          searchFilters.category[f] && locCategories.push(f);
        });
      }

      if (!!searchFilters.apiType) {
        const apiTypeSet = {
          restApi: "REST",
          asyncApi: "Async",
          bundles: "Bundles",
        };
        Object.keys(searchFilters.apiType).forEach((f) => {
          searchFilters.apiType[f] && selectedApiTypes.push(apiTypeSet[f]);
        });
      }
      if (!!searchFilters.org) {
        Object.keys(searchFilters.org).forEach((f) => {
          searchFilters.org[f] && locOrgs.push(f);
        });
      }
      if (!!searchFilters.filters) {
        Object.keys(searchFilters.filters).forEach((f) => {
          searchFilters.filters[f] && locFilters.push(f);
        });
      }
    }
    this.onEnhancedChange(selectedApiTypes, locCategories, locOrgs, locFilters);
  };

  componentDidMount() {
    if (
      Array.isArray(this.props.selectedDomainIds) ||
      Array.isArray(this.props.selectedAPIType) ||
      Array.isArray(this.props.selectedFilterType)
    ) {
      this.setState({
        selectedAPIType:
          Array.isArray(this.props.selectedAPIType) &&
          this.props.selectedAPIType.length > 0
            ? this.props.selectedAPIType
            : [],
        selectedDomainIds:
          Array.isArray(this.props.selectedDomainIds) &&
          this.props.selectedDomainIds.length > 0
            ? this.props.selectedDomainIds
            : [],
        selectedFilterType:
          Array.isArray(this.props.selectedFilterType) &&
          this.props.selectedFilterType.length > 0
            ? this.props.selectedFilterType
            : [],
      });
    } else {
      if (this.props.selectedDomainIds && this.props.selectedAPIType) {
        this.setState({
          selectedAPIType: this.props.selectedAPIType,
          selectedDomainIds: this.props.selectedDomainIds,
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    let domainsToDisplay;
    if (this.props.domains?.items) {
      domainsToDisplay = this.props.domains.items[1].dimensions
        .filter((domain) => domain.name)
        .sort(function(a, b) {
          //sorting domain list by display name
          let nameA = a.name.toUpperCase(); // ignore upper and lowercase
          let nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
    }
    // Typical usage (don't forget to compare props):
    if (this.props.domains !== prevProps.domains) {
      let options = [];
      let allApis = Array.isArray(prevProps.apis)
        ? prevProps.apis.concat(prevProps.asyncApis)
        : prevProps.asyncApis;
      options.push(
        domainsToDisplay.map((element) => {
          let obj = {
            label: element.name,
            value: element.name,
            isDisabled:
              element.visibility === "private" ||
              allApis.some((e) => e.domain === element.name)
                ? true
                : false,
            name: element.name,
          };
          return obj;
        }),
      );

      const mergeOptions = options.flat(1).sort(function(a, b) {
        //sorting domain list by display name
        let nameA = a.value.toUpperCase(); // ignore upper and lowercase
        let nameB = b.value.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

      if (options.length) {
        this.setState({
          chipDomainOptions: mergeOptions,
        });
      }
    }

    if (!!this.props.entity && Object.keys(this.state.entity).length === 0) {
      this.setState({ entity: this.props.entity });
    }

    if (
      this.state.apiBundles.length === 0 &&
      this.props?.apis?.bundles &&
      Array.isArray(this.props.apis.bundles) &&
      this.props.apis.bundles.length !== 0
    ) {
      this.setState({ apiBundles: this.props.apiBundles });
    }
  }

  render() {
    const {
      selectedAPIType,
      selectedDomainIds,
      selectedOrgs,
      selectedFilterType,
    } = this.state;
    const {
      apisLoading,
      apis = [],
      apiBundles,
      asyncApis = [],
      asyncApisLoading,
      domains,
      domainsLoading,
      cartDetails,
      apiHomeOnClickHandlers,
      belongsTo,
      orderDetails,
      sendAmplitudeData,
      existingSolutionDetails,
      disableBuildNow,
      requestStatus,
      isMsaConsented,
      fetchingDAABConsentDetails,
      requestingOrgId,
    } = this.props;

    let filteredApis = [];
    let allContractedApis = [];
    let filteredApiBundles = [];
    const fortllisCustomApis = Array.isArray(domains.items)
      ? domains.items
          .filter(
            (item) =>
              item?.name === "Categories" && Array.isArray(item.dimensions),
          )
          .map((item) => item.dimensions.map((d) => d?.name))
      : [];

    let apisToDisplay = Array.isArray(apis)
      ? apis.map((api) => {
          let customFortellisApis = Array.isArray(api.tags)
            ? api.tags.filter((t) => fortllisCustomApis.includes(t))
            : [];
          let searchTags = Array.isArray(api.tags)
            ? api.tags.filter((t) => !fortllisCustomApis.includes(t))
            : [];
          return {
            ...api,
            searchTags,
            customFortellisApis,
          };
        })
      : [];

    let asyncApisToDisplay = Array.isArray(asyncApis)
      ? asyncApis.map((api) => {
          let customFortellisApis = Array.isArray(api.tags)
            ? api.tags.filter((t) => fortllisCustomApis.includes(t))
            : [];
          let searchTags = Array.isArray(api.tags)
            ? api.tags.filter((t) => !fortllisCustomApis.includes(t))
            : [];
          return {
            ...api,
            searchTags,
            customFortellisApis,
          };
        })
      : [];

    let apiBundlesToDisplay = apiBundles && apiBundles.length ? apiBundles : [];

    //edge condition
    let apisToDisplayNew = apis && apis.length ? apis : [];
    let asyncApisToDisplayNew = asyncApis && asyncApis.length ? asyncApis : [];

    const fuzzy = this.state.advanceSearch; // fuzzy set true
    const optionsApi = {
      isCaseSensitive: false,
      includeScore: true,
      shouldSort: true,
      findAllMatches: true,
      includeMatches: true,
      threshold: 0.6,
      keys: [
        { name: "name", weight: 4 },
        { name: "searchTags", weight: 3 },
        { name: "orgName", weight: 2 },
        { name: "customFortellisApis", weight: 1 },
      ],
    };
    // match api name present within the card
    const optionsBundles = {
      isCaseSensitive: false,
      includeScore: true,
      shouldSort: true,
      findAllMatches: true,
      threshold: 0.6,
      includeMatches: true,
      keys: [
        "name",
        "description",
        // "apis.name"
      ],
    };
    if (this.state.searchText) {
      // fuzzy search
      const apiFuseIntance = new Fuse(apisToDisplay, optionsApi);
      apisToDisplay = apiFuseIntance
        .search(this.state.searchText)
        .map((e) => e.item);
      apisToDisplayNew = apiFuseIntance.search(this.state.searchText);
      const asyncApiFuseIntance = new Fuse(asyncApisToDisplay, optionsApi);
      asyncApisToDisplay = asyncApiFuseIntance
        .search(this.state.searchText)
        .map((e) => e.item);
      asyncApisToDisplayNew = asyncApiFuseIntance.search(this.state.searchText);
      const bundleFuseIntance = new Fuse(apiBundlesToDisplay, optionsBundles);
      apiBundlesToDisplay = bundleFuseIntance
        .search(this.state.searchText)
        .map((e) => e.item);
    }
    // category filter
    function filterCategory(apiListData, lowercaseCategories) {
      return (apiListData = apiListData.filter(
        (api) =>
          Array.isArray(api.tags) &&
          api.tags.some((item) =>
            typeof item === "string"
              ? lowercaseCategories.includes(item.toLowerCase())
              : lowercaseCategories.includes(
                  item.name ? item.name.toLowerCase() : "",
                ),
          ),
      ));
    }

    function filterCategoryNew(apiListData, lowercaseCategories) {
      return (apiListData = apiListData.filter(
        (api) =>
          api.item &&
          Array.isArray(api.item.tags) &&
          api.item.tags.some((item) =>
            typeof item === "string"
              ? lowercaseCategories.includes(item.toLowerCase())
              : lowercaseCategories.includes(
                  item.name ? item.name.toLowerCase() : "",
                ),
          ),
      ));
    }
    if (this.state.selectedDomainIds && this.state.selectedDomainIds.length) {
      const lowercaseCategories =
        typeof selectedDomainIds == "string"
          ? [this.state.selectedDomainIds.toLowerCase()]
          : this.state.selectedDomainIds.map((cat) => cat.toLowerCase());

      apisToDisplay = filterCategory(apisToDisplay, lowercaseCategories);
      asyncApisToDisplay = filterCategory(
        asyncApisToDisplay,
        lowercaseCategories,
      );
      if (this.state.searchText !== "") {
        apisToDisplayNew = filterCategoryNew(
          apisToDisplayNew,
          lowercaseCategories,
        );
        asyncApisToDisplayNew = filterCategoryNew(
          asyncApisToDisplayNew,
          lowercaseCategories,
        );
      }
    }
    let domainsToDisplay;
    if (domains.items) {
      domainsToDisplay = domains.items[1].dimensions
        .filter((domain) => domain.name)
        .sort(function(a, b) {
          //sorting domain list by display name
          let nameA = a.name.toUpperCase(); // ignore upper and lowercase
          let nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
    }

    const domainId =
      Array.isArray(selectedDomainIds) && selectedDomainIds.length
        ? selectedDomainIds[0]
        : selectedDomainIds;
    const domainIdValue = this.state.chipDomainOptions?.find(
      (chip) => chip.value?.toLowerCase() === domainId,
    )?.value;

    const setSearchText = (searchValue) => {
      sendAmplitudeData(AMPLITUDE_EVENTS.SEARCH_APIS, {
        [AMPLITUDE_PROPERTIES.SEARCH_APIS]: searchValue || "",
      });
      this.setState({ searchText: searchValue });
      if (searchValue === "") {
        this.setState({
          visible: PAGINATION.LIMIT,
          visibleBundle: PAGINATION_BUNDLE.LIMIT,
        });
      }
    };

    const sortFuzzyData = (filteredApis) => {
      let filterApiData = filteredApis;
      filterApiData.sort((a, b) => {
        if (a.score > b.score) {
          return 1;
        } else if (a.score < b.score) {
          return -1;
        } else {
          return 0;
        }
      });
      filterApiData = filterApiData.map((e) => e.item);
      return filterApiData;
    };

    if (selectedAPIType && selectedAPIType.length > 0) {
      if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value)
      ) {
        // only rest
        filteredApis = apisToDisplay;
        filteredApiBundles = [];
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value)
      ) {
        // only async
        filteredApis = asyncApisToDisplay;
        filteredApiBundles = [];
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value)
      ) {
        //  only bundle
        filteredApiBundles = apiBundlesToDisplay;
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value)
      ) {
        // api & async
        if (fuzzy && this.state.searchText !== "") {
          filteredApis = [...apisToDisplayNew, ...asyncApisToDisplayNew];
          filteredApis = sortFuzzyData(filteredApis);
        } else {
          filteredApis = [...apisToDisplay, ...asyncApisToDisplay];
        }
        filteredApiBundles = [];
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value)
      ) {
        // rest and bundle
        filteredApis = apisToDisplay;
        filteredApiBundles = apiBundlesToDisplay;
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value) &&
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value) &&
        !selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value)
      ) {
        // async and bundle
        filteredApis = asyncApisToDisplay;
        filteredApiBundles = apiBundlesToDisplay;
      } else if (
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[0].value) &&
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[1].value) &&
        selectedAPIType.includes(API_TYPES_DROPDOWN_OPTIONS[2].value)
      ) {
        // rest, async and bundle
        if (fuzzy && this.state.searchText !== "") {
          filteredApis = [...apisToDisplayNew, ...asyncApisToDisplayNew];
          filteredApis = sortFuzzyData(filteredApis);
        } else {
          filteredApis = [...apisToDisplay, ...asyncApisToDisplay];
        }
        filteredApiBundles = apiBundlesToDisplay;
      }
    } else {
      if (fuzzy && this.state.searchText !== "") {
        filteredApis = [...apisToDisplayNew, ...asyncApisToDisplayNew];
        filteredApis = sortFuzzyData(filteredApis);
      } else {
        filteredApis = [...apisToDisplay, ...asyncApisToDisplay];
      }
      filteredApiBundles = apiBundlesToDisplay;
    }
    // org filter
    if (
      selectedOrgs &&
      Array.isArray(selectedOrgs) &&
      selectedOrgs.length > 0
    ) {
      filteredApis = filteredApis.filter(
        (f) => selectedOrgs.indexOf(f.orgId) > -1,
      );
    }
    // hide all empty apis (i.e. no name or description)
    filteredApis = filteredApis.filter((api) => api.name && api.description);

    // should be relavance when there is search string avoid sorting
    if (!fuzzy || (fuzzy && this.state.searchText === "")) {
      filteredApis = filteredApis.sort(function(a, b) {
        // sorting apis list by name (case insensitive)
        let nameA = a.name ? a.name.toUpperCase() : "";
        let nameB = b.name ? b.name.toUpperCase() : "";
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    }
    filteredApis = [...new Set(filteredApis.map(JSON.stringify))].map(
      JSON.parse,
    );

    const hasSelectedFilters = selectedFilterType?.length > 0;
    const hasDomainIds = selectedDomainIds.length > 0;
    const hasBundleFilterSelected = selectedFilterType?.some(
      (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
    );
    const hasContractedFilterSelected = selectedFilterType?.some(
      (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[1].value,
    );

    if (hasSelectedFilters) {
      if (!hasBundleFilterSelected) {
        filteredApiBundles = [];
      }

      if (hasContractedFilterSelected) {
        filteredApis = filteredApis.filter((api) => api.isContracted === true);
      }

      if (hasBundleFilterSelected && hasDomainIds) {
        filteredApiBundles = [];
      }

      if (!hasContractedFilterSelected) {
        filteredApis = [];
      }
    } else if (hasDomainIds) {
      filteredApiBundles = [];
    }
    const showBundles = () => {
      return (
        (Array.isArray(this.state.selectedDomainIds) &&
          this.state.selectedDomainIds.length === 0 &&
          Array.isArray(this.state.selectedAPIType) &&
          this.state.selectedAPIType.length === 0 &&
          Array.isArray(this.state.selectedFilterType) &&
          this.state.selectedFilterType.length === 0) ||
        (((selectedFilterType &&
          selectedFilterType.some(
            (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
          )) ||
          (selectedAPIType &&
            selectedAPIType.some(
              (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
            ))) &&
          Array.isArray(this.state.selectedDomainIds) &&
          this.state.selectedDomainIds.length === 0)
      );
    };

    // Filter contracted APIs from the original APIs and asyncApis lists (before category filtering)
    // to ensure filters are shown even when selected category has no contracted APIs
    const contractedApis = Array.isArray(apis)
      ? apis.filter((api) => api.isContracted === true)
      : [];
    const contractedAsyncApis = Array.isArray(asyncApis)
      ? asyncApis.filter((api) => api.isContracted === true)
      : [];
    allContractedApis = [...contractedApis, ...contractedAsyncApis];

    const filteredBundles = Array.isArray(filteredApiBundles)
      ? filteredApiBundles.filter((bundle) =>
          bundle?.name
            ?.toLowerCase()
            ?.includes(this.state?.searchText?.toLowerCase()),
        )
      : [];
    const ToastContent = () => {
      return (
        <div className="api-dir-pkg_msa-toast-content">
          Comply with the{" "}
          <span
            className="api-dir-pkg_msa-toast-dialog-link"
            onClick={() => apiHomeOnClickHandlers.viewTermsDialog()}
          >
            Terms and Conditions
          </span>{" "}
          of the Addendum in order to be able to buy APIs.
        </div>
      );
    };
    const shouldShowSearchSection = !(
      this.props.isDealerPurchaseDisabled &&
      (!allContractedApis || allContractedApis.length === 0)
    );

    return (
      <>
        <div className="api-dir-pkg_main-page-wrapper">
          {shouldShowSearchSection && (
            <div className="api-dir-pkg_api-dir-search-section">
              <ApiSearchGroup
                domains={domains}
                setSearchFilters={this.handleSetSearchFilters}
                selectedDomainIds={selectedDomainIds}
                selectedApiType={selectedAPIType}
                selectedOrgs={selectedOrgs}
                selectedFilterType={selectedFilterType}
                belongsTo={this.props.belongsTo}
                sendAmplitudeData={sendAmplitudeData}
                bundles={this.props.apiBundles}
                apis={this.props.apis}
                apiHomeOnClickHandlers={apiHomeOnClickHandlers}
              />
            </div>
          )}
          <div className="api-dir-pkg_header-body-wrapper">
            {!isMsaConsented &&
              !fetchingDAABConsentDetails &&
              belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY && (
                <Toast
                  className="api-dir-pkg_inline-toast"
                  content={<ToastContent />}
                  id="toast-1"
                  variant={TOAST_VARIANTS.WARNING}
                />
              )}
            <SearchResult
              setSearchFilters={this.handleSetSearchFilters}
              domains={domains}
              searchText={this.state.searchText}
              domainsToDisplay={domainsToDisplay}
              selectedOrgs={this.state.selectedOrgs}
              count={filteredBundles.length + filteredApis.length}
              selectedDomainIds={selectedDomainIds}
              selectedAPIType={this.state.selectedAPIType}
              selectedFilterType={this.state.selectedFilterType}
              setSearchText={setSearchText}
              cartDetails={cartDetails}
              belongsTo={belongsTo}
              apiHomeOnClickHandlers={apiHomeOnClickHandlers}
              sendAmplitudeData={sendAmplitudeData}
              isMsaConsented={isMsaConsented}
            />
            {showBundles() && (
              <>
                <BundleList
                  isSearchText={this.state.searchText !== "" ? true : false}
                  apiBundles={filteredBundles
                    .sort((x, y) => x?.name?.localeCompare(y?.name))
                    .slice(0, this.state.visibleBundle)}
                  count={filteredBundles.length}
                  entity={this.state.entity}
                  environmentURLs={this.props.environmentURLs}
                  apiHomeOnClickHandlers={this.props.apiHomeOnClickHandlers}
                  existingSolutionDetails={existingSolutionDetails}
                  disableBuildNow={disableBuildNow}
                  belongsTo={belongsTo}
                  isMsaConsented={isMsaConsented}
                />
                {this.state.isPaginationRequired &&
                  this.state.visibleBundle < (filteredBundles.length || 0) && (
                    <div className="api-dir-pkg_show__more-bundles">
                      <SecondaryButton
                        onClick={this.loadMoreBundle}
                        text="Show More Bundles"
                      />
                    </div>
                  )}
              </>
            )}
            {apisLoading || asyncApisLoading ? (
              <FlexFooterContainer
                className="api-dir-pkg_circular-progress"
                align="center"
                justify="center"
              >
                <Loader />
              </FlexFooterContainer>
            ) : !(
                (filteredApiBundles && filteredApiBundles.length > 0) ||
                (filteredApis && filteredApis.length > 0)
              ) ? (
              <>
                <div className="error_div">
                  <strong>
                    <span>
                      No APIs available. Please adjust your filter criteria.
                    </span>
                  </strong>
                </div>
              </>
            ) : selectedDomainIds &&
              selectedDomainIds.length &&
              !selectedFilterType?.some(
                (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
              ) ? (
              <>
                <ApiList
                  key={selectedDomainIds}
                  domainsToDisplay={domainsToDisplay}
                  apis={filteredApis}
                  isSearchText={this.state.searchText !== "" ? true : false}
                  count={filteredApis ? filteredApis.length : 0}
                  entity={this.state.entity}
                  cartDetails={cartDetails}
                  orderDetails={orderDetails}
                  apiHomeOnClickHandlers={apiHomeOnClickHandlers}
                  belongsTo={belongsTo}
                  environmentURLs={this.props.environmentURLs}
                  requestStatus={requestStatus}
                  isMsaConsented={isMsaConsented}
                  requestingOrgId={requestingOrgId}
                  apiBundles={this.props.apiBundles}
                />
              </>
            ) : (
              <>
                <ApiList
                  apis={
                    filteredApis && filteredApis.slice(0, this.state.visible)
                  }
                  isSearchText={this.state.searchText !== "" ? true : false}
                  count={filteredApis ? filteredApis.length : 0}
                  domainsToDisplay={domainsToDisplay}
                  entity={this.state.entity}
                  cartDetails={cartDetails}
                  orderDetails={orderDetails}
                  apiHomeOnClickHandlers={apiHomeOnClickHandlers}
                  belongsTo={belongsTo}
                  environmentURLs={this.props.environmentURLs}
                  requestStatus={requestStatus}
                  isMsaConsented={isMsaConsented}
                  requestingOrgId={requestingOrgId}
                  apiBundles={this.props.apiBundles}
                />
              </>
            )}

            {this.state.isPaginationRequired &&
              this.state.visible < filteredApis.length &&
              !hasDomainIds &&
              !apisLoading &&
              !asyncApisLoading &&
              !this.state.selectedFilterType.some(
                (element) => element === FILTER_TYPES_DROPDOWN_OPTIONS[0].value,
              ) && (
                <div className="api-dir-pkg_show__more-api">
                  <SecondaryButton
                    onClick={this.loadMore}
                    text={SHOW_MORE_APIS}
                  />
                </div>
              )}
          </div>
        </div>
      </>
    );
  }
}

export default ApiSection;
